// Adapted from :
//
//   https://gist.github.com/julianocomg/296469e414db1202fc86#gistcomment-1818845
//
import { Component } from "react";
import classNames from "classnames";
import omit from "lodash/omit";

class Affix extends Component {
  static defaultProps = {
    offsetTop: null,
    offsetBottom: null
  };

  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);

    this.state = {
      affixTop: false,
      affixBottom: false
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  componentDidUpdate() {
    this.handleScroll();
  }

  get passthroughProps() {
    return omit(this.props, ["className", "offsetTop", "offsetBottom"]);
  }

  get className() {
    const className = {
      "affix-top": this.state.affixTop,
      "affix-bottom": this.state.affixBottom
    };

    if (this.props.className) {
      className[this.props.className] = true;
    }

    return classNames(className);
  }

  handleScroll() {
    const affixTop = this.state.affixTop;
    const affixBottom = this.state.affixBottom;
    const offsetTop = this.props.offsetTop;
    const offsetBottom = this.props.offsetBottom;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const scrollBottom = scrollTop + window.innerHeight;

    if (!affixTop && offsetTop && scrollTop >= offsetTop) {
      this.setState({ affixTop: true });
    } else if (affixTop && scrollTop < offsetTop) {
      this.setState({ affixTop: false });
    }

    if (!affixBottom && offsetBottom && scrollBottom <= offsetBottom) {
      this.setState({ affixBottom: true });
    } else if (affixBottom && scrollBottom > offsetBottom) {
      this.setState({ affixBottom: false });
    }
  }

  render() {
    return (
      <div {...this.passthroughProps} className={this.className}>
        {this.props.children}
      </div>
    );
  }
}

export default Affix;
